import PinchZoom from 'pinch-zoom-js';
const ProvinceSearch = () => {
    if ( document.getElementById('province_search_select2') ) {
        let placehoder = document.getElementById('province_search_select2').options[0].text;
        let strutture = document.querySelectorAll('.lp-regione__structure-list__card');
        let map = document.querySelector('.lp-regione__structure-map .pinch-zoom svg');
        let province = document.querySelectorAll('.lp-regione__structure-map .pinch-zoom svg > g');
        let pins = document.querySelectorAll('.lp-regione__structure-map .pinch-zoom svg > g > g, .lp-regione__structure-map .pinch-zoom svg > g > path:not(.st0)');

        jQuery( document ).ready(function($) {
            $(document).on('select2:open', () => {
                document.querySelector('.select2-search__field').focus();
            });
            $('#province_search_select2').select2({
                theme: "news-search",
                dropdownParent: $('#province_search_select2').parent(),
                dropdownPosition: 'below',
                templateResult: formatMe,
                placeholder: placehoder,
                allowClear: true,
                language: {
                    noResults: function () {
                      return "Nessun risultato trovato";
                    }
                }
            }).on('change', (e) => {
                if ( e.target.value != '' ) {
                    strutture.forEach(struttura => {
                        struttura.classList.add('d-none')
                        if(struttura.dataset.province == e.target.value){
                            struttura.classList.remove('d-none')
                        }
                    })
                    province.forEach(provincia => {
                        provincia.classList.remove('active');
                        map.classList.remove('filtered');
                    })
                    pins.forEach(pin => {
                        pin.classList.add('d-none');
                        let parentProvincia = pin.closest('.lp-regione__structure-map .pinch-zoom svg > g')
                        if(parentProvincia.id ==  e.target.value){
                            pin.classList.remove('d-none');
                        }
                        map.classList.add('filtered');
                    })
                    document.getElementById(e.target.value).classList.add('active')

                }else{
                    strutture.forEach(struttura => {
                        struttura.classList.remove('d-none')
                    })
                    province.forEach(provincia => {
                        provincia.classList.remove('active');
                    })
                    pins.forEach(pin => {
                        pin.classList.remove('d-none');
                    })
                    map.classList.remove('filtered');
                }
            });

        });
        function formatMe(result) {
            if (!result.id) {
                return result.text;
            }
            var query = jQuery('.select2-search__field').val();
            var str = result.text;
            var regex = new RegExp(query, 'i');
            var indexQuery = (str.toLowerCase()).indexOf(query.toLowerCase());
            var highlightText = str.substring(indexQuery, indexQuery + query.length);
            var newStr = str.replace(regex, '<span style="font-weight:bold">' + highlightText + '</span>')
            return jQuery('<span>' + newStr + '</span>');
        }

        let province_path = document.querySelectorAll('.lp-regione__structure-map .pinch-zoom svg > g > path:first-child');

        province_path.forEach(prov => {
            prov.addEventListener('click', () => {
                var provName = prov.parentElement.getAttribute('id');
                jQuery('#province_search_select2').val(provName);
                jQuery('#province_search_select2').trigger('change'); 

            })
        });
    }
}

const provincePin = () => {
    let pins = document.querySelectorAll('.lp-regione__structure-map .pinch-zoom svg > g > g, .lp-regione__structure-map .pinch-zoom svg > g > path:not(.st0)');
    pins.forEach(pin => {
        pin.addEventListener('click', () => {         
            if(document.querySelector('.lp-regione__structure-map__card')){
                document.querySelector('.lp-regione__structure-map__card').remove()
                createCard(pin)
            }else{
                createCard(pin)
            }
        })
    })
}

const collpaseTriggers = () => {
    let collapseBtn = document.querySelectorAll('.item-card__struttura button');
    let pins = document.querySelectorAll('.lp-regione__structure-map .pinch-zoom svg > g > g, .lp-regione__structure-map .pinch-zoom svg > g > path:not(.st0)');
    collapseBtn.forEach(btn => {
        btn.addEventListener('click', () => {           
            var target = btn.dataset.bsTarget ;   
            var cleanTarget = target.replace(/^#event-/, '');
            if(!btn.classList.contains('collapsed')){
                pins.forEach(pin => {
                    if (pin.id === cleanTarget) {
                        createCard(pin)         
                    }
                });
            }else{
                document.querySelector('.lp-regione__structure-map__card').remove()
            }
                        
        })
    })
}
const createCard = (pin) => {
    let strSlug = pin.id;
    let str = document.querySelector('[data-slug='+ strSlug +']');
    let strContent = str.querySelector('.item-card__content').innerHTML;

    let container = document.querySelector('.lp-regione__structure-map')
    let containerRect = container.getBoundingClientRect();
    let elementRect = pin.getBoundingClientRect();
    let positionInContainer = {
        x: ((elementRect.left - containerRect.left) / containerRect.width) * 100,
        y: ((elementRect.top - containerRect.top) / containerRect.height) * 100,
    };
    let card = document.createElement('div');
    let close = document.createElement('div');
    card.classList.add('lp-regione__structure-map__card')
    if(document.querySelector('.mappa-regione--eventi')){
        card.classList.add('event_card')
    }
    close.classList.add('lp-regione__structure-map__card-close', 'cursor-pointer')
    card.innerHTML = strContent;
    close.innerHTML = '<i class="icon-close"></i>';
    document.querySelector('.lp-regione__structure-map').appendChild(card);
    card.appendChild(close);
    card.style.top = positionInContainer.y +'%'; ;
    card.style.left = positionInContainer.x +'%'; 

    let closers = document.querySelectorAll('.lp-regione__structure-map__card-close');
    closers.forEach(close => {
        close.addEventListener('click', (e) => {
            close.parentElement.remove();
        })
    })
    if(document.querySelector('.mappa-regione--eventi')){
        scrollToEvent();
    }
}

const mapZoom = () => {
    let el = document.querySelector('.pinch-zoom');
        new PinchZoom(el, {
        tapZoomFactor: 4,
  
        onDoubleTap: (pinch, event) => {
            event.preventDefault();
        }
    });
}
const scrollToEvent = () => {
    var cards = document.querySelectorAll('.event_card');
    cards.forEach(card => {
        var button = card.querySelector('button');
        var target = button.dataset.bsTarget
        button.addEventListener('click', () =>{
            let scr =  document.querySelector(target)

            if (window.innerWidth <= 768) {  // 768px è tipicamente il punto di rottura tra mobile e desktop, ma regolalo secondo le tue esigenze
                let offset = 90;  // Personalizza questo valore per l'offset desiderato
                let yPosition = scr.getBoundingClientRect().top + window.pageYOffset - offset;
                
                window.scrollTo({
                    top: yPosition,
                    behavior: 'smooth'
                });
            } 
            // Controllo per dispositivi desktop
            else {
                let container = document.querySelector('.lp-regione__structure-list');
                
                if (container) {
                    let yPosition = scr.offsetTop; // Distanza dall'inizio del container
        
                    container.scrollTo({
                        top: yPosition,
                        behavior: 'smooth'
                    });
                }
            }
        });
    });

    
}
const mappaRegione = () => {
    if ( document.getElementById('province_search_select2')){
        ProvinceSearch();
    }
    if ( document.querySelector('.lp-regione__structure-map')){
        provincePin();
        mapZoom();
        collpaseTriggers();
    }   
    
}

export default mappaRegione;